import React from 'react';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline } from '@atlaskit/primitives';
import { VerifiedTeamIcon } from '@atlassian/people-teams-ui/verified-team-icon';
import { SearchResultContent } from '@atlassian/search-dialog';
import { ResultAvatar } from '../../common/result-avatar';
/**
 * This function renders a search result using the default component offered
 * by the search platform. Specifically, the SearchResultContent is used.
 */
export var defaultResultRenderer = function defaultResultRenderer(_ref) {
  var isCollapsed = _ref.isCollapsed,
    isKeyboardHighlighted = _ref.isKeyboardHighlighted,
    screen = _ref.screen,
    searchResult = _ref.searchResult;
  var icon = /*#__PURE__*/React.isValidElement(searchResult.icon) ? searchResult.icon : typeof searchResult.icon === 'string' ? /*#__PURE__*/React.createElement(ResultAvatar, {
    borderColor: "transparent",
    src: searchResult.icon,
    appearance: "square",
    size: "xsmall",
    testId: "result-avatar"
  }) : searchResult.iconRenderer ? searchResult.iconRenderer({
    screen: screen
  }) : /*#__PURE__*/React.createElement(ResultAvatar, {
    borderColor: "transparent",
    src: searchResult.iconUrl,
    appearance: "square",
    size: "xsmall",
    testId: "result-avatar"
  });
  var title = searchResult.isVerified ? /*#__PURE__*/React.createElement(Inline, {
    space: "space.025",
    alignBlock: "center"
  }, searchResult.title, /*#__PURE__*/React.createElement(VerifiedTeamIcon, null)) : searchResult.title;
  return /*#__PURE__*/React.createElement(SearchResultContent, {
    key: "item_".concat(searchResult.id),
    isKeyboardHighlighted: isKeyboardHighlighted,
    title: title,
    meta: searchResult.meta,
    additionalMeta: searchResult.additionalMeta,
    isCollapsed: isCollapsed,
    icon: icon
  });
};